// 系统模板http请求
import GlobalConfig from '../config/global'
import ApiPort from '../config/api-port'
import HttpAxios from './http-axios'
import {handleResponse, handleError} from '../lib/common'


let junziqianApi = GlobalConfig.domain.junziqianApi

/**
 * 获取系统模板列表
 */
export function listSystemTemplate() {
  let url = junziqianApi + ApiPort.systemTemplateController.listTpl;
  return HttpAxios.post(url, {})
    .then(handleResponse)
    .catch(handleError)
}

/**
 * 使用系统模板
 * @param data
 * @returns {Promise<T | never>}
 */
export function useTpl(data) {
  let  url = junziqianApi + ApiPort.systemTemplateController.useTpl;
  return HttpAxios.post(url, data)
    .then(handleResponse)
    .catch(handleError)
}



// WEBPACK FOOTER //
// ./assets/js/http-serve/http-sysTpl.js